export type PlayerId =
  | 'lisa'
  | 'chuck'
  | 'michael'
  | 'dave'
  | 'steven'
  | 'robert'
  | 'shaun';

export interface Player {
  id: PlayerId;
  firstName: string;
}

export const PLAYERS: readonly Player[] = [
  { id: 'lisa', firstName: 'Lisa' },
  { id: 'chuck', firstName: 'Chuck' },
  { id: 'michael', firstName: 'Michael' },
  { id: 'dave', firstName: 'Dave' },
  { id: 'steven', firstName: 'Steven' },
  { id: 'robert', firstName: 'Robert' },
  { id: 'shaun', firstName: 'Shaun' },
] as const;

export const PLAYER_IDS: readonly PlayerId[] = PLAYERS.map((p) => p.id);

export function playerFirstName(id: PlayerId): string {
  return PLAYERS.find((p) => p.id === id)?.firstName ?? id;
}

export interface PlayerMeta {
  initial: string;
  chipBg: string;
  chipBorder: string;
}

export const PLAYER_META: Record<PlayerId, PlayerMeta> = {
  michael: { initial: 'M', chipBg: '#133e7c', chipBorder: '#0abdc6' },
  lisa:    { initial: 'L', chipBg: '#47135e', chipBorder: '#ea00d9' },
  dave:    { initial: 'D', chipBg: '#093a54', chipBorder: '#05d9e8' },
  chuck:   { initial: 'C', chipBg: '#125740', chipBorder: '#3ddc97' },
  steven:  { initial: 'St', chipBg: '#3d2568', chipBorder: '#9aeffc' },
  shaun:   { initial: 'Sh', chipBg: '#42280d', chipBorder: '#ff9f1c' },
  robert:  { initial: 'R', chipBg: '#4a1525', chipBorder: '#ff8a96' },
};

export function playerMeta(id: PlayerId): PlayerMeta {
  return (
    PLAYER_META[id] ?? {
      initial: id.slice(0, 2).toUpperCase(),
      chipBg: '#133e7c',
      chipBorder: '#0abdc6',
    }
  );
}
